import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/schoolInfo',
  component: HeaderPaddingMain,
  name: 'schoolInfo',
  meta: {
    title: '学校信息',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/other/SchoolInfo.vue');
    }
  }]
}, {
  path: '/termInfo',
  component: HeaderPaddingMain,
  name: 'termInfo',
  meta: {
    title: '学期信息',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/other/TermInfo.vue');
    }
  }]
}, {
  path: '/dictionarySet',
  component: HeaderPaddingMain,
  name: 'dictionarySet',
  meta: {
    title: '字典设置',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/other/DictionarySet.vue');
    }
  }]
}, {
  path: '/systemLog',
  component: HeaderPaddingMain,
  name: 'systemLog',
  meta: {
    title: '系统日志',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/other/SystemLog.vue');
    }
  }]
}];
export default router;